import NewApiCaller, { OldApiCaller } from './ApiCaller';
import baseConfig, { paymentAjaxConfig } from './BaseAjaxConfig';
import { getHostname } from 'actions/PaymentActions/utils/hostname';
import get from 'lodash/get';
export var DeferredContent;
(function (DeferredContent) {
    DeferredContent["DEFERRED_CONTENT_REQUEST"] = "DEFERRED_CONTENT_REQUEST";
    DeferredContent["DEFERRED_CONTENT_SUCCESS"] = "DEFERRED_CONTENT_SUCCESS";
    DeferredContent["DEFERRED_CONTENT_ERROR"] = "DEFERRED_CONTENT_ERROR";
})(DeferredContent || (DeferredContent = {}));
function getPaymentAjaxConfig(getState) {
    const state = getState();
    const paymentTokenDetails = get(state, 'paymentToken') || {};
    const { dcId } = paymentTokenDetails;
    return Object.assign(Object.assign({}, paymentAjaxConfig), { hostname: __PAYMENT_API_HOST__ || getHostname(dcId) });
}
export function fetchDeferredContentAction({ url, id: contentId = '', requestToPayzippy = false, responseKey = 'RESPONSE' }) {
    const id = contentId || url;
    return (dispatch, getState) => {
        let ajaxConfig = baseConfig;
        let apiCaller = NewApiCaller;
        if (requestToPayzippy) {
            ajaxConfig = getPaymentAjaxConfig(getState);
            apiCaller = OldApiCaller;
        }
        dispatch({
            type: DeferredContent.DEFERRED_CONTENT_REQUEST,
            id
        });
        return apiCaller
            .get(Object.assign({}, ajaxConfig, {
            pathname: url,
            action: DeferredContent.DEFERRED_CONTENT_REQUEST
        }))
            .then(data => dispatch({
            type: DeferredContent.DEFERRED_CONTENT_SUCCESS,
            id,
            content: data[responseKey]
        }), err => {
            dispatch({
                type: DeferredContent.DEFERRED_CONTENT_ERROR,
                id,
                err
            });
            return Promise.reject(err);
        });
    };
}
